import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";

interface CtaBandProps {
  title: string;
  desc: string;
  primaryLabel: string;
  primaryTo: string;
  secondaryLabel?: string;
  secondaryTo?: string;
}

export default function CtaBand({
  title,
  desc,
  primaryLabel,
  primaryTo,
  secondaryLabel,
  secondaryTo,
}: CtaBandProps) {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-content mx-auto">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg bg-primary-900 px-6 md:px-14 py-12 md:py-16">
            <div className="absolute -top-16 -right-10 w-56 h-56 rounded-full bg-accent-500/20 blur-2xl"></div>
            <div className="absolute -bottom-20 left-10 w-64 h-64 rounded-full bg-primary-500/30 blur-3xl"></div>
            <div className="relative z-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-accent-300">
                  <i className="ri-lock-2-line"></i>
                  安全通道已开启
                </span>
                <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
                  {title}
                </h2>
                <p className="mt-4 text-[15px] leading-relaxed text-background-200">{desc}</p>
              </div>
              <div className="flex flex-col sm:flex-row lg:flex-col gap-3 shrink-0">
                <Link
                  to={primaryTo}
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-accent-500 text-foreground-950 font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-fill"></i>
                  {primaryLabel}
                </Link>
                {secondaryLabel && secondaryTo && (
                  <Link
                    to={secondaryTo}
                    className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md border border-background-50/25 text-background-50 font-medium hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-book-read-line"></i>
                    {secondaryLabel}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}